// Copyright (c) 2016 Deere & Company

import './pip-details.scss';
import React, {PropTypes} from 'react';
import LabeledLink from '../../../../product/shared/components/labeled-link';
import LabeledString from '../../../../shared/components/labeled-string';
import {Link} from 'react-router';
import PipProduct from '@deere/cps-it.warranty-model-factory/lib/pip-product';
import {buildDate} from '../../../../shared/services/build-date';

const PipDetails = props =>
    <div className='pip-details-section'>
        <header>
            <Link
                rel='noopener noreferrer'
                target='_blank'
                to={`pips/programs/${props.pipProduct.pipId}`}
            >
                {props.pipProduct.description}
            </Link>
        </header>
        <section className='pip-info'>
            <LabeledLink
                data={props.pipProduct.pipNumber}
                href={`/#/pips/programs/${props.pipProduct.pipId}`}
                label='PROGRAM_NUMBER'
                rel='noopener noreferrer'
                target='_blank'
            />
            <LabeledLink
                data={props.pipProduct.dtac}
                href={props.pipProduct.dtacUrl}
                label='DTAC_SOLUTION'
                rel='noopener noreferrer'
                target='_blank'
            />
            <LabeledString
                data={buildDate(props.pipProduct.expireDate)}
                label='EXPIRES'
            />
            <LabeledString
                data={props.pipProduct.pipType.value}
                label='PIP_TYPE'
            />
            <LabeledString
                data={props.pipProduct.pipStatus.value}
                label='PIP_STATUS'
            />
            <LabeledString
                data={buildDate(props.pipProduct.terminationDate)}
                label='TERMINATES'
            />
        </section>
    </div>;

PipDetails.displayName = 'PipDetails';
PipDetails.propTypes = {
    pipProduct: PropTypes.instanceOf(PipProduct).isRequired
};

export default PipDetails;



// WEBPACK FOOTER //
// ./src/pip/pip-code/components/pip-product-details/pip-details.js